import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LoadingBar from '../../common/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';
import * as irSearchActions from '../../../redux/actions/irSearchActions';

const CASE_TYPE = 'alias';


class PartiesWithAlias extends Component {
  componentDidMount() {
    if (this.props.purchase_right_away)
      this.purchaseAlias();
    else
      this.getAlias();
  }

  getAlias() {
    this.props.dispatch(irSearchActions.getCaseData({
      type: CASE_TYPE,
      case_uuid: this.props.case_uuid,
    }));
  }

  purchaseAlias() {
    this.props.dispatch(irSearchActions.purchaseCaseData({
      type: CASE_TYPE,
      case_uuid: this.props.case_uuid,
    }));
  }

  render() {
    if (!this.props.dataReady) return <LoadingBar/>;

    const errorMessage = this.props.error ? (
      <AlertError errors={this.props.error}/>
    ) : null;

    const aliases = this.props.alias;
    const receipt = this.props.receipt;

    const isEmpty = _.get(aliases, '[0][0]') == 'empty' || _.get(aliases, 'empty');

    const Aliases = (isEmpty) ? [] : aliases.map((alias, index) => {
      const partyAlias = alias.party_alias;

      const party = alias.party;
      const PartyAliasNameComponents = partyAlias.map((alias, index) => {
        return (
          <div key={index} className="ir-search-card">
            <b>{alias.name}</b>
          </div>
        );
      });

      const PartyAliasRoleAliases = partyAlias.map((alias, index) => {
        return (
          <div key={index} className="ir-search-card">{party.role}</div>
        );
      });


      return (
        <tr key={index} className={index % 2 == 0 ? 'even' : 'odd'}>
          <td>
            <div className="ir-search-card">
              <b>{party.name}</b><br/>
              <span>{party.address}</span><br/>
              {party.ssn ? <span>SSN / ITIN: {party.ssn}<br/></span> : null}
              <i>({party.role})</i><br/>
            </div>
          </td>
          <td>{PartyAliasRoleAliases}</td>
          <td>{PartyAliasNameComponents}</td>
        </tr>
      )
    });

    return (
      <div className="ir-search-query alias">
        {errorMessage}
        <FilterTable>
          {!!Aliases.length ? (
            <table className="sticky-enabled tablesorter">
              <thead>
              <tr>
                <th><span>Party</span></th>
                <th/>
                <th><span>Alias</span></th>
              </tr>
              </thead>
              <tbody>
              {Aliases}
              </tbody>
            </table>
          ) : (
            <div
              className="ir-search-status-message messages warning"
            >There Are No Parties with Alias For This Case</div>
          )}
        </FilterTable>
        <UpdateFromPacer
          pacerUpdateHandler={this.purchaseAlias.bind(this)}
          pacerReceipt={receipt}
          lastUpdated={this.props.lastUpdated}/>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const irSearch = state.get('irSearch').toJS();

  return {
    dataReady: irSearch.data_ready,
    alias: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartiesWithAlias)



// WEBPACK FOOTER //
// ./src/components/case/alias/PartiesWithAlias.js